(function() {
	function initDesignersIndex() {
		if (!document.body.classList.contains('template-list-collections')) return;
		const root = document.querySelector('[data-designers-index]');
		if (!root) return;
		const alpha = root.querySelector('[data-designers-alpha]');
		if (!alpha) return;
		const letterHeadings = root.querySelectorAll('.designers-index__letter');
		const letterLinks = alpha.querySelectorAll('a.designers-index__alpha-link[data-letter]');
		let scrollRaf = null;

		function normalizeHash(raw) {
			if (!raw || raw === '#') return '';
			const h = raw.charAt(0) === '#' ? raw.slice(1) : raw;
			let decoded = h;
			try {
				decoded = decodeURIComponent(h);
			} catch (e) {
				decoded = h;
			}
			if (decoded.toLowerCase() === 'symbol') return 'symbol';
			return decoded.toUpperCase();
		}

		function getHeaderPx() {
			const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
			return parseFloat(raw) || 0;
		}

		function updateActiveLetter() {
			const headerPx = getHeaderPx();
			const alphaH = alpha.getBoundingClientRect().height;
			const threshold = headerPx + alphaH + 8;
			let activeId = '';
			letterHeadings.forEach(function(h2) {
				if (h2.getBoundingClientRect().top <= threshold) {
					activeId = h2.id;
				}
			});
			letterLinks.forEach(function(a) {
				const letter = a.getAttribute('data-letter');
				a.classList.toggle('is-active', letter === activeId);
			});
		}

		function onScroll() {
			if (scrollRaf !== null) return;
			scrollRaf = window.requestAnimationFrame(function() {
				scrollRaf = null;
				updateActiveLetter();
			});
		}

		function scrollToId(id) {
			if (!id) return;
			const el = document.getElementById(id);
			if (!el) return;
			const headerPx = getHeaderPx();
			const top = el.getBoundingClientRect().top + window.scrollY - headerPx;
			window.scrollTo({
				top: Math.max(0, top),
				behavior: 'smooth'
			});
		}

		function applyHashFromUrl() {
			const id = normalizeHash(window.location.hash);
			if (!id) {
				updateActiveLetter();
				return;
			}
			requestAnimationFrame(function() {
				scrollToId(id);
				window.setTimeout(updateActiveLetter, 450);
			});
		}
		alpha.addEventListener('click', function(e) {
			const a = e.target.closest('a.designers-index__alpha-link');
			if (!a || !root.contains(a)) return;
			const href = a.getAttribute('href');
			if (!href || href.charAt(0) !== '#') return;
			e.preventDefault();
			const id = normalizeHash(href);
			const base = window.location.pathname + window.location.search;
			history.replaceState(null, '', base + '#' + id);
			scrollToId(id);
			const letter = a.getAttribute('data-letter');
			letterLinks.forEach(function(link) {
				link.classList.toggle('is-active', link.getAttribute('data-letter') === letter);
			});
			window.setTimeout(updateActiveLetter, 450);
		});
		window.addEventListener('hashchange', applyHashFromUrl);
		window.addEventListener('scroll', onScroll, {
			passive: true
		});
		let resizeTimer;
		window.addEventListener('resize', function() {
			window.clearTimeout(resizeTimer);
			resizeTimer = window.setTimeout(updateActiveLetter, 150);
		});

		function initPage() {
			updateActiveLetter();
			applyHashFromUrl();
		}
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', initPage, {
				once: true
			});
		} else {
			initPage();
		}
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(updateActiveLetter);
		}
	}
	initDesignersIndex();
})();
